module.exports = __webpack_public_path__ + "img/agency3_logo.ec1ab4e4.png";